import React from 'react'
import PropTypes from 'prop-types'
import { Row, Col, Button, Form } from 'reactstrap';
import { connect } from 'react-redux';

import PersonNotFound from './PersonNotFound';
import PersonConsented from './PersonConsented';
import ConsentSuccess from './ConsentSuccess';
import SubmitFailure from './SubmitFailure';
import Loading from '../app/Loading';

import { entityGet, entityPut } from '../entity/Entity';

import * as Actions from './PersonConsentActions';

class PersonConsentBody extends React.Component {
  constructor(props) {
    super(props);

    if (this.props.unionid && this.props.clubid && this.props.publicpersonid) {
      this.getPerson();
    }
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  getPerson() {
    this.props.fetchingPersonConsent()
    const parameters = {'UnionId': this.props.unionid, 'ClubId': this.props.clubid, 'PublicPersonId': this.props.publicpersonid};
    entityGet("PersonConsent", parameters, this.props.fetchPersonConsentSuccess, this.props.fetchPersonConsentFailure);
  }


    getFormValues() {
      return {
        "UnionId" : this.props.unionid,
        "ClubId" : this.props.clubid,
        "PublicPersonId" : this.props.publicpersonid,
        "Preferences" : {
         "PrivacyTermsAccepted" : this.props.unionMembership,
         "PrivacyTermsClubAccepted" : true,
        }
      }
    }

    handleSubmit(event) {
      event.preventDefault();

      this.props.submittingForm()
      var formValues = this.getFormValues()
      entityPut("PersonConsent", formValues, this.props.submitFormSuccess, this.props.submitFormFailure);
    }


  render () {
    if (this.props.failure ) {
      return <PersonNotFound clubName={this.props.clubName} />
    } else if (this.props.fetchers > 0) {
      return <Loading />;
    } else if (this.props.consentSet ) {
      return <PersonConsented unionid={this.props.unionid} clubName={this.props.clubName} />
    } else if (this.props.formSubmitSuccess) {
      return <ConsentSuccess clubName={this.props.clubName} />
    } else if (this.props.formSubmitFailure ) {
      return <SubmitFailure clubName={this.props.clubName} />
    }

    var content;
    if (this.props.unionMembership) {
      content = (<div>
                  <p>
                    Lees de onderstaande privacyverklaringen van {this.props.clubName} en
                    de {this.props.unionid} goed door voordat je ermee instemt
                    dat {this.props.fullName} wordt aangemeld bij {this.props.clubName} en
                    de {this.props.unionid}. In deze verklaringen staat
                    hoe {this.props.clubName} en de {this.props.unionid} omgaan met persoonsgegevens.
                    </p>
                    <p>
                      <a href={this.props.privacyStatementClub}  target="_blank">  Privacyverklaring {this.props.clubName} </a>
                    </p>
                    <p>
                      <a href={this.props.privacyStatementUnion}  target="_blank">  Privacyverklaring {this.props.unionid} </a>
                    </p>
                    <p>
                      Door op &quot;Bevestigen&quot; te drukken, bevestig je dat je ermee
                      hebt ingestemd dat {this.props.fullName} wordt aangemeld
                      bij {this.props.clubName} en de {this.props.unionid}.
                    </p>
                  </div>);
    } else {
      content = (<div>
                  <p>
                    Lees de onderstaande privacyverklaring van {this.props.clubName} goed
                    door voordat je ermee instemt dat {this.props.fullName} wordt
                    aangemeld bij {this.props.clubName}.
                    In deze verklaringen staat hoe {this.props.clubName} omgaat
                    met persoonsgegevens.
                    </p>
                    <p>
                      <a href={this.props.privacyStatementClub}  target="_blank">  Privacyverklaring {this.props.clubName} </a>
                    </p>
                    <p>
                      Door op &quot;Bevestigen&quot; te drukken, bevestig je dat je ermee
                      hebt ingestemd dat {this.props.fullName} wordt aangemeld
                      bij {this.props.clubName}.
                    </p>
                  </div>);
    }

    return (
      <Form onSubmit={this.handleSubmit}>
        <Row>
          <Col md={{ size: 8,offset: 2 }} className="formGroup TextCenter" >
            <h2>
            Bevestig aanmelding
            </h2>
            {content}
            <Button type="submit"
                disabled={this.props.submitting}
                className="formSubmit" >
                Bevestigen
              </Button>
            </Col>
        </Row>
      </Form>
    )
  }
}

PersonConsentBody.propTypes = {
  clubid: PropTypes.string.isRequired,
  unionid: PropTypes.string.isRequired,
  publicpersonid: PropTypes.string.isRequired,
  fetchers: PropTypes.number.isRequired,
  failure: PropTypes.bool.isRequired,

  consentSet: PropTypes.bool,
  privacyStatementClub: PropTypes.string,
  privacyStatementUnion: PropTypes.string,
  clubName: PropTypes.string,
  fullName: PropTypes.string,
  unionMembership: PropTypes.bool,

  submitting: PropTypes.bool.isRequired,
  formSubmitSuccess: PropTypes.bool.isRequired,
  formSubmitFailure: PropTypes.bool.isRequired,

  fetchingPersonConsent: PropTypes.func,
  fetchPersonConsentSuccess: PropTypes.func,
  fetchPersonConsentFailure: PropTypes.func,

  submittingForm: PropTypes.func,
  submitFormSuccess: PropTypes.func,
  submitFormFailure: PropTypes.func,


}

const mapStateToProps = state => ({
  fetchers: state.personconsent.fetchers,
  submitting: state.personconsent.submitting,
  failure: state.personconsent.failure,
  consentSet: state.personconsent.personConsent.ConsentSet,
  fullName: state.personconsent.personConsent.FullName,
  unionMembership: state.personconsent.personConsent.UnionMember,
  formSubmitSuccess: state.personconsent.formSubmitSuccess,
  formSubmitFailure: state.personconsent.formSubmitFailure,
  privacyStatementClub: state.personconsent.club.PrivacyStatementClub,
  privacyStatementUnion: state.personconsent.club.PrivacyStatementUnion,
  clubName: state.personconsent.club.Name,
  personconsent : state.personconsent,
})

const mapDispatchToProps = {
  fetchingPersonConsent: Actions.fetchingPersonConsent,
  fetchPersonConsentSuccess: Actions.fetchPersonConsentSuccess,
  fetchPersonConsentFailure: Actions.fetchPersonConsentFailure,

  submittingForm: Actions.submittingForm,
  submitFormSuccess: Actions.submitFormSuccess,
  submitFormFailure: Actions.submitFormFailure,
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PersonConsentBody)



// WEBPACK FOOTER //
// ./src/personconsent/PersonConsentBody.jsx